import json from './sprite.js';

export default {
    handle: 'SP_SPT3-Window',
    label: 'es_SPT3-Window_234684293',
    json,
};
